import { FormItem } from '@magicdoorinc/form';
import { useLocalization, LabeledTextInput } from '@magicdoorinc/ui';
import { For, Show } from 'solid-js';
import CheckboxComponent from '~/components/common/Inputs/CheckboxComponent';
import { BankAccountType } from '~/swagger/portal/Api';
import { bankAccountNumber, bankAccountRoutingNumber, bankAccountType } from '~/utils/formRules';
import type { LabeledGroupProps, InputProps } from '@magicdoorinc/ui';
import type { Component, JSX } from 'solid-js';
interface LabeledBankingInputProps extends LabeledGroupProps {
  hasError?: boolean;
  onClick?: (isMouseDown: boolean) => void;
  fieldName?: string;
}

export const LabeledBankingAccountType: Component<{
  value?: string;
  options: { label: string; value: string }[];
  error?: string;
  onInput?: (val: string) => void;
  onClick: InputProps['onClick'];
  labelJSX?: JSX.Element;
}> = (props) => {
  const handleAccountChange = (value: string) => {
    props.onInput?.(value === props.value ? '' : value);
  };

  return (
    <div class="flex flex-col gap-2">
      <div class="text-sm text-text-03">{props.labelJSX}</div>
      <div class="flex w-full gap-5">
        <For each={props.options}>
          {(option) => (
            <CheckboxComponent
              value={option.value}
              checked={props.value === option.value}
              onClick={(ismodown) => {
                {
                  handleAccountChange(option.value);
                  props.onClick?.(ismodown);
                }
              }}
              label={option.label}
            />
          )}
        </For>
      </div>

      <Show when={props.error}>
        <div class="text-xs text-red-500">{props.error}</div>
      </Show>
    </div>
  );
};

const LabeledBankingInput: Component<LabeledBankingInputProps> = (props) => {
  const { t } = useLocalization();

  return (
    <div class="flex flex-col gap-5">
      <FormItem
        label={t('Bank name')}
        placeholder={t('Enter bank name')}
        onClick={props.onClick}
        formFieldName={props.fieldName ? [props.fieldName, 'bankName'] : 'bankName'}
        component={LabeledTextInput}
        rules={[
          {
            length: [3, 100],
            message: t('{name} must be between {min} and {max} characters', { name: t('Bank name'), min: '3', max: '100' }),
          },
          { required: true, message: t('Please input bank name') },
        ]}
      />
      <FormItem
        label={t('Account number')}
        onClick={props.onClick}
        placeholder={t('Enter account number')}
        formFieldName={props.fieldName ? [props.fieldName, 'accountNumber'] : 'accountNumber'}
        component={LabeledTextInput}
        rules={bankAccountNumber(t)}
      />

      <FormItem
        label={t('Routing number')}
        onClick={props.onClick}
        placeholder={t('Enter routing number')}
        formFieldName={props.fieldName ? [props.fieldName, 'routingNumber'] : 'routingNumber'}
        component={LabeledTextInput}
        rules={bankAccountRoutingNumber(t)}
      />

      <FormItem
        onClick={props.onClick}
        formFieldName={props.fieldName ? [props.fieldName, 'accountType'] : 'accountType'}
        component={LabeledBankingAccountType}
        options={Object.entries(BankAccountType).map(([key, value]) => ({ label: t(key), value }))}
        rules={bankAccountType(t)}
        label={t('Account type')}
      />
    </div>
  );
};
export default LabeledBankingInput;
